'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "contentClassName", "orientation"];
import PropTypes from 'prop-types';
import AbstractDeviceFrame from './AbstractDeviceFrame';
import { BATTLESHIP, GYPSUM } from 'HubStyleTokens/colors';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TabletPortraitFrame = props => /*#__PURE__*/_jsx("svg", Object.assign({}, props, {
  children: /*#__PURE__*/_jsxs("g", {
    transform: "rotate(90 194 195)",
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/_jsx("path", {
      fill: GYPSUM,
      stroke: BATTLESHIP,
      d: "M-.5 15.994C-.5 6.884 6.886-.5 16.004-.5h484.992c9.112 0 16.504 7.391 16.504 16.494v356.012c0 9.11-7.386 16.494-16.504 16.494H16.004C6.892 388.5-.5 381.109-.5 372.006V15.994zm25 2.001v352.01a5.502 5.502 0 0 0 5.495 5.495h469.01a5.5 5.5 0 0 0 5.495-5.495V17.995a5.502 5.502 0 0 0-5.495-5.495H29.995a5.5 5.5 0 0 0-5.495 5.495z"
    }), /*#__PURE__*/_jsx("circle", {
      fill: BATTLESHIP,
      cx: "12",
      cy: "194",
      r: "4"
    })]
  })
}));
const TabletLandscapeFrame = props => /*#__PURE__*/_jsx("svg", Object.assign({}, props, {
  children: /*#__PURE__*/_jsxs("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/_jsx("path", {
      fill: GYPSUM,
      stroke: BATTLESHIP,
      d: "M-.5 15.994C-.5 6.884 6.886-.5 16.004-.5h484.992c9.112 0 16.504 7.391 16.504 16.494v356.012c0 9.11-7.386 16.494-16.504 16.494H16.004C6.892 388.5-.5 381.109-.5 372.006V15.994zm25 2.001v352.01a5.502 5.502 0 0 0 5.495 5.495h469.01a5.5 5.5 0 0 0 5.495-5.495V17.995a5.502 5.502 0 0 0-5.495-5.495H29.995a5.5 5.5 0 0 0-5.495 5.495z"
    }), /*#__PURE__*/_jsx("circle", {
      fill: BATTLESHIP,
      cx: "12",
      cy: "194",
      r: "4"
    })]
  })
}));
const TABLET_DEVICE_SPECS = {
  tabletPortrait: {
    Template: TabletPortraitFrame,
    top: 25.5,
    right: 13.5,
    bottom: 13.5,
    left: 13.5,
    height: 519,
    width: 390
  },
  tabletLandscape: {
    Template: TabletLandscapeFrame,
    top: 13.5,
    right: 13.5,
    bottom: 13.5,
    left: 25.5,
    height: 390,
    width: 519
  }
};
const UIDeviceFrameTablet = props => {
  const {
      children,
      className,
      contentClassName,
      orientation
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const computedSpecs = orientation === 'landscape' ? TABLET_DEVICE_SPECS.tabletLandscape : TABLET_DEVICE_SPECS.tabletPortrait;
  return /*#__PURE__*/_jsx(AbstractDeviceFrame, Object.assign({}, rest, {
    className: classNames(className, 'UIDeviceFrameTablet'),
    contentClassName: contentClassName,
    spec: computedSpecs,
    orientation: orientation,
    children: children
  }));
};
UIDeviceFrameTablet.propTypes = {
  children: PropTypes.node.isRequired,
  contentClassName: PropTypes.string,
  orientation: PropTypes.oneOf(['portrait', 'landscape'])
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIDeviceFrameTablet.defaultProps = {
  orientation: 'portrait'
};
UIDeviceFrameTablet.displayName = 'UIDeviceFrameTablet';
export default UIDeviceFrameTablet;